/*
	A hello for anyone who opens DevTools, in whatboxart?'s editorial key: a flat
	ink banner with a hard geekgroup-gold edge, then a couple of plain lines.
	Mirrors the main geekgroup.app and Tally console greetings, in boxart's look.
*/

import { latest } from './changelog'

export default function hello() {

	if (typeof window === 'undefined' || !window.console || !console.log) return

	var mono = "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"

	var banner = [
		'background: #1c1a16',
		'color: #fdfbf6',
		'font: 600 13px/1.6 ' + mono,
		'padding: 10px 14px',
		'border-left: 3px solid #b8860b',
		'white-space: pre'
	].join(';')

	console.log(
		'%c▚ whatboxart? · guess the daily board game from its cover\n  v' + latest + ' · poking around? cool, but you won\'t find the answer here :) let me know if you have any questions',
		banner
	)

	var gold = 'color: #b8860b; font: 500 12px/1.7 ' + mono
	var muted = 'color: #9a9284; font: 500 12px/1.7 ' + mono

	console.log('%c> built by geekgroup · phil@geekgroup.app', gold)
	console.log('%c> bugs and ideas welcome', muted)

}
